import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
export function showAlert({
  type,
  message,
  title
}) {
  FloatingAlertStore.addAlert({
    message,
    titleText: title,
    type
  });
}
export function addSuccessAlert({
  title,
  message
} = {}) {
  showAlert({
    type: 'success',
    title: title || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.setup-alerts.updateSuccess.title"
    }),
    message: message || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.setup-alerts.updateSuccess.message",
      "data-selenium-test": "alert-success"
    })
  });
}
export function addErrorAlert({
  title,
  message
} = {}) {
  showAlert({
    type: 'danger',
    title: title || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.setup-alerts.updateFailure.title"
    }),
    message: message || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.setup-alerts.updateFailure.message"
    })
  });
}